<!--冻结信息提示-->
<template>
  <div class="freeze-info app-container">
    <div v-if="language === 'zh_CN'">
      <p>冻结点位如想解冻，按照以下方式之一进行解冻操作：</p>
      <p>➢已经冻结的点位在服务中心或其他经销商处报升级订单，升级到更高的一个级别</p>
      <p>➢已经冻结的点位在服务中心或其他经销商处报重消订单，需购买50PV以上的重消</p>
      <p>➢冻结的点位作为推荐人，推荐一个新点位加入</p>
      <p>➢自己重新注册购买一个新的点位，并与老的点位进行绑定关联</p>
      <p>操作完成后,次日请重新登录</p>
    </div>
    <div v-else-if="language === 'es_ES'">
      <p>Sigue uno de los métodos a continuación para descongelar el punto congelado:</p>
      <p>➢Realice un pedido de mejora a un rango superior para el punto congelado en el Centro de Servicio u otro
        distribuidor.</p>
      <p>➢Realice un pedido de recompra de al menos 50 PV para el punto congelado en el Centro de Servicio u otro
        distribuidor.</p>
      <p>➢Un titular de puntos congelados puede actuar como un referente y recomendar un nuevo punto para unirse.</p>
      <p>➢Vuelve a registrar un nuevo punto y enlázalo al punto congelado.</p>
      <p>Después de completar la operación, por favor inicie sesión nuevamente al día siguiente.</p>
    </div>
    <div v-else>
      <p>Follow one of the methods below to unfreeze the frozen point:</p>
      <p>➢1.Place an upgrade order to a higher rank for the frozen point at the Service Center or other distributor.</p>
      <p>➢2. Place a repurchase order of at least 50 PV for the frozen point at the Service Center or other distributor.
      </p>
      <p>➢3.A frozen point holder can act as a referrer and recommend a new point to join.</p>
      <p>➢4.Re-register a new point and link it to the frozen point.</p>
      <p>After completing the operation, please log in again the next day.</p>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: 'freeze-info',
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'isFreeze',
      'language',
      'userCode',
      'token'
    ]),
  },
}

</script>

<style lang="scss" scoped></style>
